import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bowser from 'bowser';
import { BROWSER_MAP } from 'bowser/src/constants';

export default class View extends Component {
  renderContent = (src, contentType) => {
    switch (contentType) {
      case 'pdf': {
        return this.renderPdfContent(src);
      }
      case 'image': {
        return this.renderImageContent(src);
      }
      default: {
        return this.renderImageContent('/images/cat_anim.gif');
      }
    }
  };

  renderPdfContent = (src) => {
    if (Bowser.parse(window.navigator.userAgent).browser.name === BROWSER_MAP.firefox) {
      return (
        <object
          data={`${src}#toolbar=1`}
          type="application/pdf"
          aria-label="Document viewer"
          style={{
            width: 'calc(100vw - 200px)',
            height: '100vh',
          }}
        />
      );
    }
    return (
      <embed
        src={src}
        type="application/pdf"
        style={{
          width: 'calc(100vw - 200px)',
          height: '100vh',
        }}
      />
    );
  };

  renderImageContent = (src) => (
    <img
      src={src}
      alt="attachment"
      style={{
        height: 'auto',
        maxHeight: '100vh',
        maxWidth: '100%',
        userSelect: 'none',
      }}
    />
  );

  render() {
    const { data } = this.props;
    const { contentType, src } = data;
    return (
      <div
        style={{
          position: 'relative',
          textAlign: 'center',
        }}
      >
        {this.renderContent(src, contentType)}
      </div>
    );
  }
}

View.propTypes = {
  data: PropTypes.shape({
    contentType: PropTypes.string,
    src: PropTypes.string,
  }).isRequired,
};
